import React, { ReactElement } from 'react';
import { Button, CircularProgress } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { WalletConnectGuard } from 'modules/auth';
import {
  globalTranslation,
  mergeTranslations,
  useTranslation,
} from 'modules/i18n';

import { translation } from './translation';

const mergedTranslation = mergeTranslations(globalTranslation, translation);

interface IActionButton extends IActionButtonContent {
  isSubmitDisabled: boolean;
}

interface IActionButtonContent {
  isLoading: boolean;
  isStake?: boolean;
  isZeroAmount: boolean;
}

export function ActionButton({
  isSubmitDisabled,
  ...props
}: IActionButton): ReactElement {
  return (
    <WalletConnectGuard>
      <Button
        fullWidth
        color="primary"
        disabled={isSubmitDisabled}
        size="large"
        type="submit"
      >
        <ActionButtonContent {...props} />
      </Button>
    </WalletConnectGuard>
  );
}

function ActionButtonContent({
  isLoading,
  isStake,
  isZeroAmount,
}: IActionButtonContent): ReactElement {
  const { classes } = useStyles();
  const { t, keys } = useTranslation(mergedTranslation);

  if (isLoading)
    return (
      <div className={classes.root}>
        <CircularProgress size={24} />

        {isStake ? t(keys.staking) : t(keys.unstaking)}
      </div>
    );

  if (isZeroAmount) return <>{t(keys.enterAmount)}</>;

  return <>{isStake ? t(keys.stake) : t(keys.unstake)}</>;
}

const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2.5),
  },
}));
